// The analytics tiers an event can be on. Mirrors `functions/analytics/schema.js`,
// which is the authority — the tier decides whether the Firestore triggers keep
// the summary live, and that decision is made server-side.
export const ANALYTICS_TIERS = ['free', 'pro']

// An unset or unrecognized tier reads as free, so the dropdown shows a real
// option rather than going blank.
export function normalizeTier(tier) {
  return ANALYTICS_TIERS.includes(tier) ? tier : 'free'
}
